import React from 'react';
import * as Constants from "../../Common/constants";
import courseImage from "./Group-course.png"

export default class HoleItem extends React.Component {
    constructor(props) {

        super(props);

    }

    componentWillMount() {
       
    }

    componentDidMount() {
        /*const context = this.canvasA.getContext('2d');

        const image = new Image();
        image.src = "../../Groupe-course.png";
            image.onload = () => {
            context.drawImage(image, 0, 0, this.canvasA.width, this.canvasA.height);
  };*/
        drawStrokes(this.props.strokes, this.props.players);
    }

    componentWillReceiveProps(nextProps) {
       
        drawStrokes(nextProps.strokes,this.props.players);
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }


    render() {
        // <img src={imagepath} />
        console.info('HoleItem - render called.');
        let w = this.props.width ? this.props.width : 375;
        let h = this.props.height ? this.props.height : 600;

        let holeindex = this.props.holeindex;
        //let imagepath = Constants.SERVER + "/holeimage/" + Constants.LEADERBOARD_ID + "/" + holeindex + ".jpeg";
        //let imagepath = courseImage;//Constants.IMAGE_SERVER+ "/" + this.props.tid + "/hole" + holeindex + ".jpeg";
            let imagepath = Constants.IMAGE_SERVER+ "/102/hole" + holeindex + ".png";

        if (!holeindex) {
            return null;
        }

        return (

            <div id="hole" height={h + "px"} width={w + "px"} 
                style={{ backgroundColor:'rgb(247,247,247)',backgroundRepeat: 'no-repeat', backgroundImage: `url(${imagepath})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>

                <canvas id="myCanvas" height={h + "px"} width={w + "px"}
                    style={{ border: '0px solid #d3d3d3' }}>
                    Your browser does not support the HTML5 canvas tag.
                    </canvas>

            </div>



        );
    }
}

function drawStrokes(strokes, players) {
    if (!strokes) {
        return;
    }
    var c = document.getElementById("myCanvas");
    var ctx = c.getContext("2d");
    //clear canvas
    ctx.clearRect(0, 0, c.width, c.height);
    


    var playerStrokes = new Object();
    strokes.forEach(function (e) {
       
        if (!playerStrokes[e.playerId]) {
            playerStrokes[e.playerId] = [];
        }

        playerStrokes[e.playerId].push(e);

    });

    var playerToColor = new Object();

    var colors = ["yellow", "red", "blue", "black"];
    var colorindex = 0;
    if (players){
        players.forEach(element => {
            playerToColor[element.id] = element.color;//colors[colorindex++];
        });
    }
    
    var colorindex = 0;
    Object.keys(playerStrokes)
        .forEach(function (playerid) {

            var playerStrokeArray = playerStrokes[playerid];
            playerStrokeArray.reverse();
            var x1 = c.width / 2;
            var y1 = c.height;
            var x2 = 190;
            var y2 = 550;
            var color = playerToColor[playerid];
            if (!color){
                color = "yellow";
            }
            
            playerStrokeArray.forEach(function (e) {

                var element = JSON.parse(e.data);

                x2 = element.xCoord;
                y2 = element.yCoord;
                drawLine(x1, y1, x2, y2, color);
                drawCircle(x2, y2, color);
                x1 = x2;
                y1 = y2;
            });

        });
}
function drawCircle(x, y, color) {
    var c = document.getElementById("myCanvas");
    if (!c){
        return;
    }
    var ctx = c.getContext("2d");
    ctx.beginPath();
    ctx.arc(x, y, 8, 0, 2 * Math.PI);
    ctx.fillStyle = color;
ctx.fill();
   
}
function drawLine(x1, y1, x2, y2, color) {
    var c = document.getElementById("myCanvas");
    if (!c){
        return;
    }
    var ctx = c.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.lineWidth = 2;
    ctx.strokeStyle = color;
    ctx.stroke();
}




// WEBPACK FOOTER //
// ./src/Components/HoleItem/HoleItem.js